<script lang="ts" setup>
import { usePreviewImg } from "@/use/common";
import { Image } from "vant";
import { Ref, ref } from "vue";
import { useGenStyle } from "@/stores/genStyle";
import CheckCircleFillIcon from "@/components/icon/CheckCircleFillIcon.vue";

const props = defineProps<{
  selectedStyleId?: number;
}>();
const emit = defineEmits(["update:selectedStyleId"]);
const genStyle = useGenStyle();
const selectedStyleId = ref<number>();
const onRandomClick = () => {
  selectedStyleId.value = genStyle.getRandStyle().id;
  emit("update:selectedStyleId", selectedStyleId.value);
};

const onItemClick = (id: number) => {
  selectedStyleId.value = id;
  emit("update:selectedStyleId", selectedStyleId.value);
};

export interface ImageStyleSelectionInstance {
  selectedStyleId: Ref<number | undefined>;
}

defineExpose<ImageStyleSelectionInstance>({
  selectedStyleId,
});
</script>
<template>
  <div class="flex flex-col gap-4">
    <div class="flex justify-between items-center">
      <div>{{ $t("trait.artStyleTitle") }}</div>
      <button class="btn btn-xs rounded" @click="onRandomClick">
        {{ $t("trait.random") }}
      </button>
    </div>
    <div class="grid grid-cols-3 gap-1">
      <div
        v-for="item in genStyle.styleList"
        :key="item.id"
        :class="{
          'border-primary': selectedStyleId === item.id,
          'border-transparent': selectedStyleId !== item.id,
        }"
        class="rounded overflow-hidden relative w-full aspect-[3/4] border-2"
        @click="onItemClick(item.id)"
      >
        <div>
          <Image
            :src="usePreviewImg(item.coverImage)"
            class="w-full"
            crossorigin="anonymous"
          />
          <check-circle-fill-icon
            v-if="selectedStyleId === item.id"
            class="text-primary absolute right-1 bottom-1 icon-xl rounded-full"
          />
        </div>
        <div
          :class="{
            'badge badge-neutral absolute left-1 bottom-1': true,
            'bg-red-500': selectedStyleId === item.id,
          }"
          class="badge badge-neutral absolute left-1 bottom-1 border-0"
        >
          {{ item.id }}
        </div>
      </div>
    </div>
  </div>
</template>
